<template>
  <div class="container-inner pt-30 pb-70" style="max-width: 770px; margin: 0 auto;">
    <recommend-what></recommend-what>
    <recommend-steps></recommend-steps>
    <div class="text-center mt-50">
      <button class="button is-primary is-long" @click="back()">戻る</button>
    </div>
  </div>
</template>
<style lang="scss" src="../recommend.scss">
</style>

<script>
import RecommendSteps from '../guide/steps';
import RecommendWhat from '../guide/what';

export default {
  name: 'RecommendGuide',
  components: {
    'recommend-steps': RecommendSteps,
    'recommend-what': RecommendWhat
  },
  data() {
    return {
      returnLink: null,
      profileInfo: {},
      rating_good: {
        rating: true,
        count: 10
      },
      rating_bad: {
        rating: false,
        count: 5
      },
      addresses: []
    };
  },
  created() {
    this.returnLink = this.$route.query && this.$route.query.return_link ? this.$route.query.return_link : null;
  },
  methods: {
    back() {
      if (!this.returnLink) return;

      this.$router.push(this.returnLink);
    }
  }
};
</script>
